import LTR from "@brand-icons/ploom/ui-download/ui-download-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiDownloadIcon = iconFactory("UiDownloadIcon", LTR);
